import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { creditEvaluationsKeys } from "api/creditEvaluations/queries";
import { updateCustomerSpouse as updateCustomerSpouseAPI } from "api/customers";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";

import SpouseForm, { SpouseFormValues } from "./SpouseForm";

interface AddSpouseModalProps {
  isOpen: boolean;
  handleClose: () => void;
  customerId: string;
  creditEvaluationId: string;
}

const AddSpouseModal = ({
  isOpen,
  handleClose,
  customerId,
  creditEvaluationId,
}: AddSpouseModalProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const queryClient = useQueryClient();

  const { mutateAsync: updateCustomerSpouse, status } = useMutation(
    async (data: { spouse: string }) => {
      const res = await updateCustomerSpouseAPI(data.spouse, customerId);
      await queryClient.invalidateQueries(
        creditEvaluationsKeys.details(creditEvaluationId),
      );
      return res.data;
    },
  );

  const handleSubmit = async (values: SpouseFormValues) => {
    await updateCustomerSpouse(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="Add Spouse"
        subtitle="Link a spouse to this credit evaluation."
      />
      <SpouseForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        customerId={customerId}
      />
    </AppDialog>
  );
};

export default AddSpouseModal;
